import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import {   useParams } from 'react-router-dom';

import TitlesLabels from "../../helpers/TitlesLabels";
import { pageTitle  } from "../../actions";

import DailyGlanceEventsFeaturedLayout from "./DailyGlanceEventsFeaturedLayout";
import { DailyGlanceEventItemTemplate, DailyGlanceEventListLoader } from "./DailyGlanceArticleWidgets";
import { getListEvents } from "../../helpers/QueryDailyGlanceEvents";
import NoRecordAvailable from "../../components/common/NoRecordAvailable";
import { handleClickAdverstisement } from "../../helpers/UtilitiesDailyGlance";


const DailyGlanceEvents = () => {

    const dispatch = useDispatch();
    const { dateYYmmdd } = useParams();

    let result_Db = '';

    const [ showListLoader , setShowListLoader ] = useState(true);
    const [ eventList , setEventList ] = useState([]);
    const [ dateSelected , setDateSelected ] = useState('');

    const getingEventList = async () => {

        setShowListLoader(true);
        result_Db = await getListEvents({ view_all : 1});
        setShowListLoader(false);

        if ( parseInt(result_Db.status??0)===1 ){
            
            if ( parseInt(result_Db.count??0)>0 ){
                setEventList(result_Db.list??[]);
            }
        }
    }

    useEffect( async () => {
        dispatch( pageTitle(`${TitlesLabels.general.events}`) );
        getingEventList();

        try {
            let dateYYmmddParam = atob(dateYYmmdd);
            setDateSelected(dateYYmmddParam);

        } catch(e) {
      
        }

    }, [] );



    return (
        
        <DailyGlanceEventsFeaturedLayout menuTitle={TitlesLabels.general.events} typeName="events">
            <div className="col-lg-10 mx-auto">
            
            {
                showListLoader ?
                    <DailyGlanceEventListLoader />
                :
                <>
                    {
                        Object.keys(eventList).length===0 ?
                            <NoRecordAvailable />
                        :
                            <div className="list-article-height-auto">
                                <ul   className="ul-global-list ul-dglance-list cursor-pointer text-lowercase font-gotham-book fs-14 fs-md-14">
                                {
                                    Object.entries(eventList).map( ([key, row] ) =>
                                        <DailyGlanceEventItemTemplate detail={row} displayType={`list`} key={key} dateSelected={dateSelected} />
                                    )
                                }
                                </ul>
                            </div>
                    }
                </>
            }

            {
                 Object.keys(eventList).length>0 &&
                 <div className="ads-image mt-3"  style={{ backgroundImage: `url('${eventList[0].ads_image??''}')`}} onClick={ () => handleClickAdverstisement( eventList[0],1, dispatch ) }></div>
            }
            </div>
        </DailyGlanceEventsFeaturedLayout>
        
            
    )
}

export default DailyGlanceEvents;